export interface HubSpotField {
  name: string
  value: string
}

export interface HubSpotCommunicationConsent {
  subscriptionTypeId: number
  text: string
  value: boolean
}

export interface HubSpotLegalConsent {
  consentToProcess: boolean
  text?: string
  communications?: HubSpotCommunicationConsent[]
}

function getCookie(name: string): string | undefined {
  if (typeof document === "undefined") return undefined
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : undefined
}

export async function submitHubSpotForm(options: {
  portalId: string
  formId: string
  fields: HubSpotField[]
  legalConsent?: HubSpotLegalConsent
}): Promise<void> {
  const hutk = getCookie("hubspotutk")
  const legalConsent = options.legalConsent
  const communications = legalConsent?.communications?.map((item) => ({
    subscriptionTypeId: item.subscriptionTypeId,
    text: item.text,
    value: item.value,
  }))

  const response = await fetch(
    `https://api.hsforms.com/submissions/v3/integration/submit/${options.portalId}/${options.formId}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        fields: options.fields.map((field) => ({
          objectTypeId: "0-1",
          name: field.name,
          value: field.value,
        })),
        context: {
          pageUri: window.location.href,
          pageName: document.title,
          ...(hutk ? { hutk } : {}),
        },
        ...(legalConsent
          ? {
              legalConsentOptions: {
                consent: {
                  consentToProcess: legalConsent.consentToProcess,
                  ...(legalConsent.text ? { text: legalConsent.text } : {}),
                  ...(communications?.length ? { communications } : {}),
                },
              },
            }
          : {}),
      }),
    }
  )

  if (!response.ok) {
    let detail = ""
    try {
      detail = await response.text()
    } catch {
      detail = ""
    }
    throw new Error(detail || `HubSpot submission failed (${response.status})`)
  }
}
